import { FormActions } from "../../components/common/FormActions";
import { BooleanTags } from "../../components/common/registerUtils";
import { IFormSection } from "../../types/common";
import {
  createColumn,
  createViewAction,
  formatDateTime,
  getForm,
  getRegister,
} from "../../utils/helpers";
import { URL_MARK_TRANSACTION } from "../../utils/urls";

export const useMarkTransaction = () => {
  const tableColumns = () => [
    createColumn("created_by_name", true, "Created By"),
    createColumn("created_at", true, "Created At"),
    createColumn("updated_at", true, "Updated At"),
    createColumn("change_type", true, "Change Type"),
    createColumn("change_reason", true, "Change Reason"),
    createColumn("is_processed", true, "Is Processed"),
    createColumn("updated_by", true, "Updated By"),
    createColumn("transaction", true, "Transaction"),
    createColumn("actions", false, "Actions"),
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        updated_at: formatDateTime(item?.updated_at),
        created_at: formatDateTime(item?.created_at),
        is_processed: <BooleanTags status={item?.is_processed} />,
        actions: (
          <FormActions
            actions={[createViewAction(URL_MARK_TRANSACTION, item?.id)]}
          />
        ),
      };
    }),
  ];

  const viewData = (item) => {
    if (!item) {
      return {
        sections: [
          {
            title: "Error",
            fields: {
              message: "No data available",
            },
          },
        ],
      };
    }

    return {
      sections: [
        {
          title: "Mark Transaction Details",
          fields: {
            created_by_name: item?.created_by_name,
            created_at: formatDateTime(item?.created_at),
            updated_at: formatDateTime(item?.updated_at),
            declaration: <BooleanTags status={item?.declaration} />,
            deleted: <BooleanTags status={item?.deleted} />,
            change_type: item?.change_type,
            provider_ref_id: item?.provider_ref_id,
            change_reason: item?.change_reason,
            is_processed: <BooleanTags status={item?.is_processed} />,
            updated_by: item?.updated_by,
            transaction: item?.transaction,
          },
        },
      ],
    };
  };

  const formRoute = getForm(URL_MARK_TRANSACTION);

  return { tableColumns, tableData, viewData, formRoute };
};

export const useMarkTransactionForm = () => {
  //   {
  //     "transaction": "100021",
  //     "change_type": "mark_as_success", //mark_as_failed,mark_as_fraud,unmark_as_fraud, mark_as_success, mark_as_pending
  //     "provider_ref_id": "services@ura.go.ug", //necessaru for marking as success
  //     "change_reason":"Failed at the telecom but available as success on telecom statement"
  // }
  const sections: IFormSection[] = [
    {
      title: "Mark Transaction Details",
      fields: [
        {
          field_name: "transaction",
          label: "Transaction",
          type: "text",
          props: {
            required: true,
          },
        },
        {
          field_name: "change_type",
          label: "Change Type",
          type: "select",
          props: {
            required: true,
            options: [
              { value: "mark_as_success", label: "Mark as Success" },
              { value: "mark_as_failed", label: "Mark as Failed" },
              { value: "mark_as_fraud", label: "Mark as Fraud" },
              { value: "unmark_as_fraud", label: "Unmark as Fraud" },
              { value: "mark_as_pending", label: "Mark as Pending" },
            ],
          },
        },
        {
          field_name: "provider_ref_id",
          label: "Provider Ref ID",
          type: "text",
          props: {
            required: true,
          },
        },
        {
          field_name: "change_reason",
          label: "Change Reason",
          type: "textarea",
          props: {
            required: true,
          },
        },
      ],
    },
  ];

  const redirect = getRegister(URL_MARK_TRANSACTION);
  return { sections, redirect };
};
